import React, { FC, ChangeEvent, useState, useEffect } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';

type MonetaryValueInputProps = {
    onValueChange?: (value: string) => void;
    allowEmpty?: boolean;
} & TextFieldProps;

const MonetaryValueInput: FC<MonetaryValueInputProps> = ({
    label,
    onValueChange,
    allowEmpty,
    ...props
}: MonetaryValueInputProps) => {
    const [value, setValue] = useState<string>(allowEmpty ? '' : '0');
    const { value: inputValue, ...remainingProps } = props;
    const regexStr = /^-?\d*[,.]?\d{0,2}$/;
    const onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (value && !regexStr.test(value)) {
            return event.preventDefault();
        }
        setValue(value);
        if (onValueChange) {
            onValueChange(value);
        }
    };

    useEffect(() => {
        if (inputValue === 0) {
            setValue('0');
            return;
        }
        setValue((inputValue as string) || (allowEmpty ? '' : '0'));
    }, [props.value]);

    return (
        <TextField
            label={label}
            onChange={onInputChange}
            {...remainingProps}
            value={value}
            type="text"
            margin="dense"
        />
    );
};

export default MonetaryValueInput;
